'use strict';

import { module } from '../app';
import pubsubService from '../services/pubsub.service';
import { ChatModuleConfiguration } from '@magview/techpad-upgrade-module';
import SessionTimer from '../services/sessionTimer'
import * as _ from "lodash";

module.controller('MainCtrl', [
  '$rootScope', '$scope', '$ionicSideMenuDelegate', 'authService', '$location', '$ionicPopover', 
  'techpadConfig', 'signalrService', 'modalService', 'eventsMgr', '$ionicLoading',
  async function ($rootScope, $scope, $ionicSideMenuDelegate, authService, $location, $ionicPopover, 
    techpadConfig, signalrService, modalService, eventsMgr, $ionicLoading) {

    if(techpadConfig.settings && authService.loggedIn){

      //Check on initial load it session is not expired to redirect to login to handle browser back button 
      try {        
        const isSessionValidResponse = await authService.checkSessionValid();
      } catch (errorResponse) {
        if(errorResponse && errorResponse.status === 401){
          console.error(errorResponse);
        }else{
          modalService.showErrorMessage(errorResponse, 'Error checking session');
        }                      
        return authService.logoutOnSessionExpired();
      }

      const sessionSettings = {
        sessionTimeoutMinutes: techpadConfig.settings.SessionExpirationTimeout,
        warnBeforeSessionTimeoutMinutes: techpadConfig.settings.SessionWarnTimeout,
        sessionDynamicLabels: techpadConfig.settings.SessionDynamicLabels,
        portalUrl: authService.currentMagViewUrl(),
        modalService: modalService,
        authToken: authService.getAuthToken()
      };
      const sessionTimer = new SessionTimer(sessionSettings, authService.logoutOnSessionExpired, authService.checkIfLoggedIn);
      sessionTimer.start();  
    }    

    $rootScope.toggleLeft = _.debounce(function () {
      $ionicSideMenuDelegate.toggleLeft();
    }, 100);
    
    $rootScope.logout = async function (beforeLogoutCallback) {
      eventsMgr.send('diagram:clearProblemSelection');
      eventsMgr.send('diagram:lockDragging');
      let confirmed = await modalService.showConfirmation(null, 'Are you sure you want to log out of Techpad ?');
      if (!confirmed) {
        eventsMgr.send('diagram:unlockDragging');
      } else {

        if (techpadConfig.settings && techpadConfig.settings.IsShowChatMenuItem) {
          $ionicLoading.show({
            template: 'Logging out from chat...'
          });
          pubsubService.dispatch('USER_LOGGED_OUT');
        } else {
          if(beforeLogoutCallback){
            await beforeLogoutCallback();
          }
          authService.logout();
          eventsMgr.send('diagram:unlockDragging');
        }
      }
    };

    $rootScope.isOnline = () => signalrService.isConnected;

    $rootScope.tryReconnectAgain = function () {
      signalrService.tryReconnectAgain();
    };

    $rootScope.getUserName = authService.getDisplayName;
    $rootScope.isNotHome = function () {
      return $location.path().indexOf('/patient') > 0;
    };

    if (authService.loggedIn/* && authService.shouldCheckIfAlreadyLoggedIntoChat*/ && techpadConfig.settings && techpadConfig.settings.IsShowChatMenuItem) {
      ChatModuleConfiguration.apiEndpoint = techpadConfig.settings.ChatServiceUrl;
      // pubsubService.dispatch('USER_ALREADY_LOGGED_IN');
    }

    $rootScope.isDragMenuEnabled = function () {
      return $location.path().indexOf('/worklist') < 0 &&
        $location.path().indexOf('/patient') < 0 &&
        $location.path().indexOf('/home') < 0 &&
        $location.path().indexOf('/diagram') < 0 &&
        $location.path().indexOf('/editDiagram') < 0 &&
        $location.path().indexOf('/conversations') < 0;
    };

    $ionicPopover.fromTemplateUrl('views/templates/settingsPopover.html', { scope: $scope }).then(function (popover) {
      $scope.popover = popover;
    });
    if (techpadConfig.settings && techpadConfig.settings.IsShowChatMenuItem) {
      pubsubService.off('SHOW_LOADING_SCREEN');
      pubsubService.on('SHOW_LOADING_SCREEN', (message) => $ionicLoading.show({ template: message || 'Logging out...' }));
      pubsubService.off('HIDE_LOADING_SCREEN');
      pubsubService.on('HIDE_LOADING_SCREEN', () => $ionicLoading.hide());
      pubsubService.off('SHOW_ERROR');
      pubsubService.on('SHOW_ERROR', async (message) => {
        await modalService.showAlertAsync(message);
      });
      pubsubService.off('TECHPAD_LOGOUT');
      pubsubService.on('TECHPAD_LOGOUT', () => {
        authService.logout();
      });
      pubsubService.off('SHOW_NO_CONNECTION_ERROR');
      pubsubService.on('SHOW_NO_CONNECTION_ERROR', async (message) => {
        await modalService.showAlertAsync(message);
        console.log(' * * * * * * * * *dispatching change variable event');
        pubsubService.dispatch('SHOW_NO_CONNECTION_ERROR_CLOSED');
      });
      pubsubService.off('LOGGING_OUT_DONE');
      pubsubService.on('LOGGING_OUT_DONE', () => {
        console.log('LOGGING_OUT_DONE');
        $ionicLoading.hide();
        authService.logout();
        eventsMgr.send('diagram:unlockDragging');
      });
      pubsubService.off('RELOGIN_REQUIRED');
      pubsubService.on('RELOGIN_REQUIRED', async () => {
        console.log('RELOGIN_REQUIRED');
        //let confirmed = await modalService.showConfirmation(null, 'Your chat session is not longer valid, relogin is required. Logout now?');
        //pubsubService.dispatch('ON_LOGOUT_CONFIRMATION_CLOSED');
        //if (confirmed) {
          //$ionicLoading.show({
            //template: 'Logging out from chat...'
          //});
          pubsubService.dispatch('USER_LOGGED_OUT');
        //} else {
          //pubsubService.dispatch('REQUEST_FOR_LOGOUT_REJECTED');
        //}
      });
      // pubsubService.on('CHAT_HUB_RECONNECTING', () => {
      //   $ionicLoading.show({
      //     template: 'Reconnecting to chat ...'
      //   });
      // });
      // pubsubService.on('CHAT_HUB_RECONNECTED', () => {
      //   $ionicLoading.hide();
      // });
      // pubsubService.on('CHAT_HUB_DISCONNECTED', () => {
      //   $ionicLoading.hide();
      // });

      pubsubService.off('SHOW_LOADING_MESSAGE');
      pubsubService.on('SHOW_LOADING_MESSAGE', (message) => {
        $ionicLoading.show({
          template: message || 'Loading'
        });
      });

      pubsubService.off('HIDE_LOADING_MESSAGE');
      pubsubService.on('HIDE_LOADING_MESSAGE', () => {
        $ionicLoading.hide();
      });
    }
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/main.js